var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-layout" },
    [
      _c("div", { staticClass: "input-tip error" }, [
        _vm._v(
          "提示:跨机构调拨时,资产如果在套装中,将解除关联套装,如果资产是套装主资产则套装将解散。"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right-toolbar mb5 fr" }, [
        _c("span", [
          _vm._v(
            "已选择(" +
              _vm._s((_vm.transVoucherInfo.itemList || []).length) +
              ")"
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        { ref: "deviceItem", attrs: { model: _vm.transVoucherInfo } },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: {
                data: _vm.transVoucherInfo.itemList.slice(
                  _vm.startIndex,
                  _vm.endIndex
                ),
                border: "",
                maxHeight: "500",
                "tooltip-effect": "dark"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "innerCode",
                  label: "资产编号",
                  fixed: "left",
                  width: "150"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "table-cell-link",
                            on: {
                              click: function($event) {
                                _vm.viewAssetInfo(rows.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(rows.row.innerCode))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "innerNo",
                  label: "外部资产编码",
                  width: "180",
                  align: "left"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "assetType",
                  width: "100",
                  label: "管理方式",
                  align: "center",
                  fixed: "left"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.assetTypeMap[rows.row.assetType]))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "title",
                  width: "200",
                  label: "资产描述全称"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "fixedSpec",
                  width: "180",
                  label: "规格"
                }
              }),
              _vm._v(" "),
              _vm.transVoucherInfo.reserveFlag
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "reserved",
                      width: "80",
                      label: "预定情况"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  rows.row.reserved ? "已被预定" : "可以预定"
                                )
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "transQuantity",
                  label: "调拨数量",
                  width: "80",
                  align: "right"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "控制方式", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.splitible ? "按金额" : "按数量")
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "整批调拨", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: scope.row.transAll,
                              expression: "scope.row.transAll"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            disabled:
                              _vm.id != null ||
                              scope.row.assetType == _vm.commonDevcVal
                          },
                          domProps: {
                            checked: Array.isArray(scope.row.transAll)
                              ? _vm._i(scope.row.transAll, null) > -1
                              : scope.row.transAll
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = scope.row.transAll,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        scope.row,
                                        "transAll",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        scope.row,
                                        "transAll",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(scope.row, "transAll", $$c)
                                }
                              },
                              function($event) {
                                _vm.splitFlagChange(scope.$index)
                              }
                            ]
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "quantity",
                  label: "本次调拨数量",
                  width: "100"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.assetType == _vm.commonDevcVal
                          ? _c("span", [_vm._v(_vm._s(scope.row.quantity))])
                          : _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "itemList." + scope.$index + ".quantity",
                                  rules: {
                                    validator: _vm.inputTransAvQuantity,
                                    trigger: "blur"
                                  }
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "input-content-right",
                                  attrs: {
                                    disabled:
                                      _vm.disabledQuantity(
                                        scope.row.splitible,
                                        scope.row.splitFlag
                                      ) || _vm.srcCheck,
                                    type: "number",
                                    min: "1"
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.transAvQuantityChange(scope)
                                    }
                                  },
                                  model: {
                                    value: scope.row.quantity,
                                    callback: function($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "quantity",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "scope.row.quantity"
                                  }
                                })
                              ],
                              1
                            )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "theUnit",
                  label: "单位",
                  width: "60"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "splittedAmount",
                  width: "100",
                  label: "调拨原值(元)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.assetType == _vm.commonDevcVal
                          ? _c("span", [_vm._v(_vm._s(rows.row.orgWorth))])
                          : _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "itemList." +
                                    rows.$index +
                                    ".splittedAmount",
                                  rules: {
                                    validator: _vm.inputSplittedAmount,
                                    trigger: "blur"
                                  }
                                }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: rows.row.splittedAmount,
                                      expression: "rows.row.splittedAmount",
                                      modifiers: { number: true }
                                    }
                                  ],
                                  staticClass: "input-content-right",
                                  staticStyle: { width: "90%" },
                                  attrs: {
                                    disabled:
                                      !rows.row.splitible ||
                                      !rows.row.splitFlag ||
                                      _vm.srcCheck,
                                    type: "number",
                                    min: "0"
                                  },
                                  domProps: { value: rows.row.splittedAmount },
                                  on: {
                                    change: function($event) {
                                      _vm.splittedAmountChange(rows)
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        rows.row,
                                        "splittedAmount",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function($event) {
                                      _vm.$forceUpdate()
                                    }
                                  }
                                })
                              ]
                            )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "orgWorth",
                  width: "80",
                  label: "资产原值(元)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.assetOrgWorth != null
                          ? _c("span", [
                              _vm._v(_vm._s(rows.row.assetOrgWorth.toFixed(2)))
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", label: "调入机构", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.dstMerchantId != scope.row.retailerId &&
                        scope.row.dstMerchantName != null
                          ? _c("span", [
                              _vm._v(_vm._s(scope.row.dstMerchantName))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.dstMerchantId != scope.row.retailerId &&
                        scope.row.dstMerchantName != null &&
                        scope.row.dstComFullName != null
                          ? _c("span", [_vm._v("/")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(scope.row.dstComFullName || ""))
                        ]),
                        _vm._v(" "),
                        !_vm.taxRateChange && _vm.id == null
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                attrs: { align: "right" },
                                on: {
                                  click: function($event) {
                                    _vm.selectDstBizUnitName(scope.$index)
                                  }
                                }
                              },
                              [_vm._v("选择机构")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dstComNo", label: "调入机构编号", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dstCostCenterCode",
                  label: "调入成本中心",
                  width: "160"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "srcComFullName",
                  label: "调出部门全称",
                  width: "140",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "srcRealComCode",
                  label: "调出公司编码",
                  width: "160"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "srcCostCenterCode",
                  label: "调出成本中心",
                  width: "160"
                }
              }),
              _vm._v(" "),
              _vm.srcNormalFlag
                ? _c("el-table-column", {
                    attrs: {
                      prop: "taxRate",
                      label: "税率(%)",
                      align: "right",
                      width: "100"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            !_vm.taxRateChange
                              ? _c("span", [_vm._v(_vm._s(scope.row.taxRate))])
                              : _vm.taxRateChange
                              ? _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "请选择税率",
                                      disabled: _vm.srcCheck
                                    },
                                    on: { change: _vm.rateChange },
                                    model: {
                                      value: scope.row.taxRate,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "taxRate", $$v)
                                      },
                                      expression: "scope.row.taxRate"
                                    }
                                  },
                                  _vm._l(_vm.fiscalTaxMarkList, function(item) {
                                    return _c("el-option", {
                                      key: item.rate,
                                      attrs: {
                                        label: item.rate,
                                        value: item.rate
                                      }
                                    })
                                  })
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "deprMonth",
                  label: "入账时间",
                  width: "150",
                  align: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.fiscalInTime != null
                          ? _c("span", [_vm._v(_vm._s(rows.row.fiscalInTime))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "memo",
                  label: "备注",
                  width: "100",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            disabled: _vm.taxRateChange,
                            type: "textarea"
                          },
                          on: { change: _vm.memoChange },
                          model: {
                            value: scope.row.memo,
                            callback: function($$v) {
                              _vm.$set(scope.row, "memo", $$v)
                            },
                            expression: "scope.row.memo"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "tmpNo",
                  width: "250",
                  label: "系统编号",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "quantity2",
                  label: "含报废数量",
                  width: "120"
                }
              }),
              _vm._v(" "),
              _vm.devcCustTag1.enabled == true
                ? _c("el-table-column", {
                    attrs: {
                      prop: "devcCustTag1Val",
                      label: _vm.devcCustTag1.dispName,
                      width: "120"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.devcCustTag2.enabled == true
                ? _c("el-table-column", {
                    attrs: {
                      prop: "devcCustTag2Val",
                      label: _vm.devcCustTag2.dispName,
                      width: "120"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.devcCustTag3.enabled == true
                ? _c("el-table-column", {
                    attrs: {
                      prop: "devcCustTag3Val",
                      label: _vm.devcCustTag3.dispName,
                      width: "120"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        !_vm.taxRateChange && !_vm.srcCheck
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.removeDeviceItem(scope.$index)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pagination-layout",
              staticStyle: { overflow: "hidden" }
            },
            [
              _vm.totalCount > 10
                ? _c("el-pagination", {
                    staticClass: "fr",
                    attrs: {
                      background: "",
                      "page-size": _vm.pageSize,
                      "page-sizes": _vm.pageSizes,
                      "current-page": _vm.pageNumber,
                      total: _vm.totalCount,
                      layout: "prev, pager, next, jumper, sizes, total"
                    },
                    on: {
                      "current-change": _vm.handlePageChange,
                      "size-change": _vm.handleSizeChange
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-761f2ce8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-761f2ce8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/transVoucher/ShopDeviceTransVoucherDevice.vue
// module id = 2554
// module chunks = 0